import { load } from 'cheerio';
import { getRawContent } from './IOPageContentSelector';
/**
 * Extracts description HTML for IO provider by cleaning unwanted elements.
 */
export function extractIOPageDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    const pageContent = getRawContent($).clone();

    const unwantedSelectors = [
        '.io_mm_outer',
        '.cartInfo',
        '.pageDateRangeWrapper',
        '.io_category_wrapper',
        '.category_id',
        '.cat_div_wrapper',
        '.io_catdiv2',
        '.io_landingpages',
        '.io_cat_longdescription',
        '.io_all_item_cat',
        '.io_item2_listrent',
        '.elementor-form-fields-wrapper',
        '.category-container',
        '.service-area-map',
        '.hero-content',
        '.elementor-testimonial',
        '.e-con-inner',
        '.wpcp-carousel-preloader',
        '.form-builder',
        '.loader-container',
        '.elementor-image-carousel-wrapper'
    ];

    unwantedSelectors.forEach(selector => {
        pageContent.find(selector).remove();
    });

    // remove any forms
    pageContent.find('form').remove();

    return pageContent.html() || '';
}
